// routes
import { PATH_JOBS, PATH_EVENT, PATH_SCOUT, PATH_AX } from '../../../routes/paths';
// components
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  event: getIcon('icon-coin-mono'),
  medal: getIcon('icon-medal-check-mono'),
  search: getIcon('ic_search'),
  super: getIcon('icon-lightning-mono'),
  twinkle: getIcon('icon-twinkle-circle-mono'),
  crown: getIcon('icon-crown-mono'),
};

const navConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    subheader: 'app',
    items: [
      // pass = true 이면 패스, 안보임. pass = false 이면 메뉴 보임.
      { title: '채용공고 등록하기', path: PATH_JOBS.root, icon: ICONS.search, matchLabel: true, },
      { title: '나중을 위해 미리 확보하기', path: PATH_SCOUT.root, icon: ICONS.crown, scoutLabel: false, },
    ],
  },
  {
    subheader: 'event',
    items: [
      { title: 'AI 도입, 지금 시작하세요', path: PATH_AX.root, icon: ICONS.twinkle },
      { title: '10만원 할인 이벤트', path: PATH_EVENT.invitation, icon: ICONS.event },
    ],
  },
  // APP
  // ----------------------------------------------------------------------
  // import Label from '../../../components/Label';
  // {
  //   subheader: 'app',
  //   items: [
  //     {
  //       title: 'mail',
  //       path: PATH_WORKS.root,
  //       icon: ICONS.user,
  //       info: (
  //         <Label variant="outlined" color="error">
  //           +32
  //         </Label>
  //       ),
  //     },
  //     { title: 'chat', path: PATH_WORKS.root, icon: ICONS.user },
  //     { title: 'calendar', path: PATH_WORKS.root, icon: ICONS.invoice },
  //     { title: 'kanban', path: PATH_WORKS.root, icon: ICONS.kanban },
  //   ],
  // },
];

export default navConfig;
